import Cookies from "js-cookie";

const canUseDOM = typeof document !== "undefined";
const cookieName = "lll-ecom-correlation-id";

const getCorrelationId = (req) => {
  let correlationId = "";

  if (req) {
    if (req.cookies && req.cookies[cookieName]) {
      correlationId = req.cookies[cookieName];
    }
  } else if (canUseDOM) {
    if (Cookies.get(cookieName) !== undefined) {
      correlationId = Cookies.get(cookieName);
    }
  }

  return correlationId;
};

export default getCorrelationId;
